__turbopack_context__.v({
  "compass": "Compass-module__YbX0aa__compass",
  "indicator": "Compass-module__YbX0aa__indicator",
  "ticks": "Compass-module__YbX0aa__ticks",
});
